import * as React from "react";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import TextArea from "../../../hiberUiKit/src/atoms/TextArea/TextArea";
import {Option} from "ts-option";
import Toast from "../../helper/Toast";
import AccountingNote from "../../../model/invoice/note/AccountingNote";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";
import {OnFailure, OnSuccess} from "../../../store/action/actionHelpers";

interface IProps {
	/**
	 * Note to edit.
	 */
	noteToEdit?: Option<AccountingNote>;
	/**
	 * On cancel click.
	 */
	onCancel?: () => void;
	/**
	 * Add note.
	 */
	addNote: (noteContent: string, onSuccess: OnSuccess, onFailure: OnFailure) => void;
	/**
	 * Update note.
	 */
	updateNote: (noteId: string, noteContent: string, onSuccess: OnSuccess, onFailure: OnFailure) => void;
}

interface IState {
	/**
	 * Indicating if request to server is in progress.
	 */
	isLoading: boolean;
	/**
	 * Note content.
	 */
	noteContent: string;
}

export default class AccountingNoteTab extends React.Component<IProps, IState> {

	constructor(props: IProps) {
		super(props);
		this.state = {
			isLoading: false,
			noteContent: ""
		};

		this.addNote = this.addNote.bind(this);
		this.updateNote = this.updateNote.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onFailure = this.onFailure.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onAddSuccess = this.onAddSuccess.bind(this);
		this.onUpdateSuccess = this.onUpdateSuccess.bind(this);
	}

	componentDidMount() {
		if (this.props.noteToEdit.isDefined) {
			this.setState({noteContent: this.props.noteToEdit.map(note => note.noteText).getOrElse("")});
		}
	}

	componentWillReceiveProps(nextProps: IProps) {
		if (this.props.noteToEdit.orNull != nextProps.noteToEdit.orNull) {
			this.setState({noteContent: nextProps.noteToEdit.map(note => note.noteText).getOrElse("")});
		}
	}

	render() {
		// TODO: user mentions
		return (
			<div className="c-note-tab c-common-details_activity-tabs-container_note-input">
				<TextArea value={this.state.noteContent}
						  placeholder={"Write a simple note..."}
						  onChange={this.onChange}
						  autoSize/>
				<ButtonPrimary label={this.props.noteToEdit.isDefined ? "Update Note" : "Add Note"}
							   onClick={this.onSubmit}
							   disabled={this.state.isLoading || !this.state.noteContent.trim().length}/>
			</div>
		);
	}

	addNote() {
		this.props.addNote(this.state.noteContent, this.onAddSuccess, (error) => this.onFailure(error, true));
	}

	updateNote() {
		this.props.noteToEdit.map(note =>
			this.props.updateNote(note.id, this.state.noteContent, this.onUpdateSuccess, (error) => this.onFailure(error))
		);
	}

	private onChange(evt: React.ChangeEvent<HTMLTextAreaElement>) {
		this.setState({noteContent: evt.target.value});
	}

	private onSubmit() {
		this.setState({isLoading: true});
		if (this.props.noteToEdit.isDefined) {
			this.updateNote();
		}
		else {
			this.addNote();
		}
	}

	/**
	 * Adding new note success callback.
	 */
	private onAddSuccess() {
		this.setState({isLoading: false, noteContent: ""});
		Toast.success("Note added successfully.", "Create Note")
	}

	/**
	 * Editing note success callback.
	 */
	private onUpdateSuccess() {
		this.setState({isLoading: false, noteContent: ""});
		Toast.success("Note edited successfully", "Edit Note")
	}

	/**
	 * Adding new note failure callback.
	 */
	private onFailure(error: any, addingNote: boolean = false) {
		this.setState({isLoading: false});
		let title: string;
		if (addingNote) {
			title = "Create Note error";
		}
		else {
			title = "Update Note error"
		}
		notifyBugsnagAndShowToast(error, title);
	}
}
